<script>
import axios from 'axios'
import { Base64 } from 'js-base64'
import moment from 'moment'
import { saveAs } from 'file-saver'

export default {
  name: 'DictionaryImport',
  props: {
    entity: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      dialog: false,
      file: null,
      fileData: [],
    }
  },
  watch: {
    dialog(value) {
      if (value) this.$refs.file.click()
    },
  },
  methods: {
    import(file) {
      this.loading = true
      const data = {
        data: Base64.encode(file),
      }
      return axios.post(`/api/1/${this.entity}/import`, data)
    },
    onFilePicked(event) {
      const file = event.target.files[0] || event.dataTransfer.files[0]
      if (!file) return
      if (file.size / 1048576 > 20) {
        this.$store.commit('notifications/ADD', {
          type: 'error',
          message: this.$t('error_document-specification-upload-file-too-big'),
        })
        this.$refs.file.value = null
        return
      }
      this.file = file
      this.$refs.file.value = null
    },
    upload() {
      this.loading = true
      const reader = new FileReader()
      reader.onload = () => {
        try {
          this.fileData = JSON.parse(reader.result).goodsList
        } catch (error) {
          //
        }
        this.import(reader.result)
          .then(({ data }) => {
            this.close()
            this.$emit('successfully')
            this.createLog(data)
            this.$store.commit('notifications/ADD', {
              type: 'success',
              message: this.$t('titles__success'),
            })
          })
          .catch(() => {})
          .then(() => {
            this.loading = false
          })
      }
      reader.readAsText(this.file)
    },
    close() {
      this.dialog = false
      this.loading = false
      this.file = null
    },
    createLog(data) {
      const log = {}
      const { allCount, created, errors, skip, updated } = data
      log.allCount = allCount
      log.created = created.map(elem => this.getDataObject(elem))
      log.errors = errors
      log.skip = skip.map(elem => this.getDataObject(elem))
      log.updated = updated.map(elem => this.getDataObject(elem))
      this.downloadLog(log)
    },
    getDataObject(id) {
      return this.fileData.find(elem => elem.id === id) || id
    },
    downloadLog(json) {
      const name = this.$t(`import_log_${this.entity}`)
      const date = moment().format('YYYY-MM-DD_HH-mm-ss')
      const file = new File([JSON.stringify(json)], `${name}_${date}.json`, {
        type: 'application/json',
      })
      saveAs(file)
    },
  },
}
</script>

<template>
  <v-dialog
    v-model="dialog"
    max-width="400"
  >
    <v-btn
      slot="activator"
      color="primary"
    >
      {{ $t('buttons__import') }}
    </v-btn>
    <v-card>
      <v-card-text>
        <v-text-field
          :value="file ? file.name : null"
          :label="$t('label__file')"
          prepend-icon="insert_drive_file"
          readonly
          @click="$refs.file.click()"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="secondary"
          @click="close()"
        >
          {{ $t('buttons__cancel') }}
        </v-btn>
        <v-btn
          :loading="loading"
          color="primary"
          @click="upload()"
        >
          {{ $t('buttons__import') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <input
      ref="file"
      class="fileInput"
      type="file"
      name="file"
      @change="onFilePicked"
    >
  </v-dialog>
</template>

<style lang="scss" scoped>
.fileInput {
  position: absolute;
  left: -99999px;
}
</style>
